import React, { useEffect } from 'react';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageLayout } from '@src/common/PageLayout';
import { FileUpload as FileUploadComp } from '@src/common/FileUploadV2';
import { Card } from '@uhg-abyss/web/ui/Card';
import { StateSelect } from '../Inputs/StateSelect/StateSelect';
import { City } from '../Inputs/City';
import { ZipCode } from '../Inputs/ZipCode';
import { StreetLine } from '../Inputs/StreetLine';

const Upload = styled('div', {
  '& [data-testid*="remove-icon"]': {
    marginLeft: '15%',
  },
});

const Heading = styled.p({
  paddingTop: '0px',
  fontSize: '12px',
  paddingBottom: '18px',
  textAlign: 'left',
  fontFamily: '$primary',
});
const AlignZip = styled('div', {
  marginLeft: '10px',
});

const Space = styled('div', {
  marginBottom: '16px',
});

const Text = styled('p', {
  lineHeight: '22px',
  marginBottom: '1px',
});

export const PrimaryServicing = () => {
  useEffect(() => {}, []);

  return (
    <PageLayout>
      <Card
        header="Primary servicing address"
        id="location-primary-service-label"
      >
        <Card.Section>
          <Text>Provide your practice's primary servicing address.</Text>
          <Heading>
            Primary servicing location cannot be a P.O. Box. All addresses will
            be checked and verified.
          </Heading>

          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <StreetLine
                id="address-primary-servicing-street-line-1-input"
                model="address.primaryServicing.streetLine1"
                label="Street line 1"
                streetLine="1"
                required
              />
            </Space>
          </Grid.Col>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <StreetLine
                id="address-primary-servicing-street-line-2-input"
                model="address.primaryServicing.streetLine2"
                label="Street line 2"
                streetLine="2"
              />
            </Space>
          </Grid.Col>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <City
                id="primary-servicing-address-city-input"
                model="address.primaryServicing.city"
                label="City"
                required
              />
            </Space>
          </Grid.Col>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <Layout.Group>
                <StateSelect
                  model="address.primaryServicing.state"
                  id="address-primaryServicing-state-select"
                  required
                />
                <AlignZip>
                  <ZipCode
                    id="primary-servicing-address-zipCode-input"
                    model="address.primaryServicing.zipCode"
                    label="ZIP Code"
                    required
                  />
                </AlignZip>
              </Layout.Group>
            </Space>
          </Grid.Col>
          <Grid.Col span="100%" css={{ padding: '0px' }}>
            <Upload>
              <FileUploadComp
                id="upload-primary-servicing-address-proof-button"
                model="address.primaryServicingProof"
                label="Proof of servicing address"
                required
              />
            </Upload>
          </Grid.Col>
        </Card.Section>
      </Card>
    </PageLayout>
  );
};
